import { useContext  } from 'react'
import styles from "./RegionPage.module.css";
import Select from './SubComponents/Select'
import { CurrentPage , UserValues , UserErrors , UserButtons } from '../../Context/Context'



function RegionPage() {

  const [currentPageState , setCurrentPageState] = useContext(CurrentPage)
  const [ userValuesState , setuserValuesState  ] = useContext(UserValues)
  const [ userErrorsState , setuserErrorsState ] = useContext(UserErrors)
  const [ userButtonsState , setuserButtonsState ] = useContext(UserButtons)

  const changeHandlerRegionNumber = e => {
    setuserValuesState({...userValuesState, regionNumber : e.target.value})
 }


const changeHandlerRegionName = e => {
  setuserValuesState({...userValuesState, regionLink : e.target.value , regionName : e.target.options[e.target.selectedIndex].text })
}



  const onclickRegionPage = () => {


  
    // disable valider button
    setuserButtonsState({...userButtonsState , RegionPageButtonDisabled : true})

    // wait 1 sec
    setTimeout(
      () => {
        if(userValuesState.regionName.length > 1 || userValuesState.regionNumber.length > 1 ){
          //change page
          setCurrentPageState('LogPage')
        }else{
          // enable button valider
          setuserButtonsState({...userButtonsState , RegionPageButtonDisabled : false})

          // show error
          setuserErrorsState({...userErrorsState , regionPageError : true})

        }
      } , 
      1000
    );
  


  
  }



  return (
    <div className={styles.container}>
      <div className={styles.welcome}>
        <img alt=""  src="./images/welcome.png" />
      </div>
      <div className={styles.second}>
        <img alt=""  src="./images/second.png" />
      </div>
      <div className={styles.error} style={userErrorsState.regionPageError ? {display : 'block'} : {display : 'none'} } >
      Veuillez ressaisir votre identifiant et votre code personnel.
      </div>
      <div className={styles.input}>
        <input type="text" placeholder="Ex. 75 pour Paris" value={userValuesState.regionNumber} onChange={changeHandlerRegionNumber} />
      </div>
      <div className={styles.ou}>Ou</div>
      <div className={styles.select}>
        <Select value={userValuesState.regionLink} onchange={changeHandlerRegionName} />
      </div>
      <button className={styles.valider + " noselect"} style={ userButtonsState.RegionPageButtonDisabled ? {backgroundColor : '#98cbd3'} :{backgroundColor : '#007d8f'} } disabled={userButtonsState.RegionPageButtonDisabled} onClick={onclickRegionPage} >Valider</button>
      <div className={styles.voir}>
        <img alt=""  src="./images/voir.png" />
      </div>
    </div>
  );
}

export default RegionPage;
